import { createStore } from 'vuex'
import tagsview from './tagsview'
export default createStore({
  state: {
    admin:{uname:'',relname:'',master:0}
  },
  mutations: {
    UpAdmin:function (state,val){
      state.admin=val;
    },
  },
  actions: {
  },
  modules: {
    tagsview
  }
})
